/* eslint-disable @typescript-eslint/no-inferrable-types */
import { MAX_INTEGER } from "common/constants";
import {
  Debtor,
  DebtorSummaries,
  GenericResponse,
  OverdueDebtors,
  PaginatedDebtorBackOrders,
  PaginatedDebtorOrderHistories,
  PaginatedDebtorTransactions,
} from "types/model.types";
import { authApi } from "./";

const apiDebtorPrefix = "debtor";

export const getOverdueAccount = async (
  downloadCsv: boolean = false,
): Promise<void | OverdueDebtors> => {
  if (downloadCsv) {
    // CSV mode
    const response = await authApi.post(
      `${apiDebtorPrefix}/getOverdueAccounts`,
      {
        downloadCsv: true,
      },
      { responseType: "blob" },
    );

    const blob = new Blob([response.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `Overdue-Accounts.csv`;
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);
    return;
  }

  const { data } = await authApi.post<OverdueDebtors>(
    `${apiDebtorPrefix}/getOverdueAccounts`,
  );
  return data;
};

export const getDebtorSummary = async (): Promise<void | DebtorSummaries> => {
  const { data } = await authApi.post<DebtorSummaries>(
    `${apiDebtorPrefix}/getSummary`,
  );
  return data;
};

/** Debtor inquiry sectios */
export const getDebtorTransactions = async (
  id: number,
  pageNumber: number = 1,
  pageSize: number = 30,
): Promise<void | PaginatedDebtorTransactions> => {
  const { data } = await authApi.post<PaginatedDebtorTransactions>(
    `${apiDebtorPrefix}/getDebtorTransactions`,
    {
      id,
      pageNumber,
      pageSize,
    },
  );
  return data;
};
export const getDebtorBackOrders = async (
  id: number,
  pageNumber: number = 1,
  pageSize: number = 30,
): Promise<void | PaginatedDebtorBackOrders> => {
  const { data } = await authApi.post<PaginatedDebtorBackOrders>(
    `${apiDebtorPrefix}/getDebtorBackOrders`,
    {
      id,
      pageNumber,
      pageSize,
    },
  );
  return data;
};
export const getDebtorOrderHistories = async (
  id: number,
  pageNumber: number = 1,
  pageSize: number = 30,
  donwloadCsv: boolean = false,
  dateFrom: string | null = null,
  dateTo: string | null = null,
  productCodeFrom: number = 0,
  productCodeTo: number = MAX_INTEGER,
): Promise<void | PaginatedDebtorOrderHistories> => {
  if (donwloadCsv) {
    // CSV mode
    const response = await authApi.post(
      `${apiDebtorPrefix}/getDebtorOrderHistories`,
      {
        id,
        pageNumber,
        pageSize,
        downloadCsv: true,
        dateFrom,
        dateTo,
        productCodeFrom,
        productCodeTo,
      },
      { responseType: "blob" },
    );

    const blob = new Blob([response.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `CustomerOrderHistory-${id}.csv`;
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);
    return;
  }

  const { data } = await authApi.post<PaginatedDebtorOrderHistories>(
    `${apiDebtorPrefix}/getDebtorOrderHistories`,
    {
      id,
      pageNumber,
      pageSize,
      downloadCsv: false,
      dateFrom,
      dateTo,
      productCodeFrom,
      productCodeTo,
    },
  );

  return data;
};
export const getDebtor = async (id: number): Promise<void | Debtor> => {
  const { data } = await authApi.post<Debtor>(`${apiDebtorPrefix}/get`, { id });
  return data;
};

export const submitDebtor = async (payload: Debtor): Promise<void | Debtor> => {
  const { data } = await authApi.post<Debtor>(`${apiDebtorPrefix}/submit`, {
    payload,
  });
  return data;
};

export const requestNewIdCheck = async (
  requestId: number | undefined,
): Promise<void | GenericResponse> => {
  const { data } = await authApi.post<GenericResponse>(
    `${apiDebtorPrefix}/requestId`,
    {
      requestId,
    },
  );

  return data;
};
